import type { Dispatch, ReactNode, RefObject, SetStateAction } from 'react';

import type { ModuleOrPlanActionOrgUnit } from 'src/types/orgUnit';

export interface NodeObject {
  disabled: boolean;
  icon?: ReactNode;
  label?: ReactNode;
  showCheckbox: boolean;
  title?: string;
  value: number;
  children?: NodeObject[];
}

export enum CHECKBOX_MODE {
  NONE = 0,
  SINGLE = 1,
  MULTI = 2,
}

export const ORG_UNIT_FILTER_NAME = 'orgUnit';

export interface OrgUnitMap {
  [key: string]: {
    childrenLoaded: boolean;
    childrenRequested: boolean;
    orgUnit: ModuleOrPlanActionOrgUnit;
    reference?: RefObject<HTMLElement>;
  };
}

export interface TreeItemChild {
  value: string;
  label: string;
  children: TreeItemChild[];
}

export interface OrgTreeState {
  latestSelectedOrgUnit: ModuleOrPlanActionOrgUnit | undefined;
  setLatestSelectedOrgUnit: Dispatch<
    SetStateAction<ModuleOrPlanActionOrgUnit | undefined>
  >;
  selectedOrgUnits: ModuleOrPlanActionOrgUnit[];
  setSelectedOrgUnits: Dispatch<SetStateAction<ModuleOrPlanActionOrgUnit[]>>;
  orgUnitMap: OrgUnitMap;
  setOrgUnitMap: (orgUnitMap: OrgUnitMap) => void;
  nodes: NodeObject[];
  setNodes: Dispatch<SetStateAction<NodeObject[]>>;
}
